import dates from "@/services/date";
import store from "@/store";
import company from "../../services/company";

let parseDateTime = function(value) {
  return dates.jsonDateToLocaleDateTimeNS(value, company.getLocaleFormat(store.state));
};

export default {
  install: function (Vue) {
    Vue.filter('parseDateTimeNs', parseDateTime);
  }
}
